import { css } from '@emotion/react';
import { applyFont, tokens } from '@domain-group/fe-brary';

const { colors, spacing, typography } = tokens;

export const card = css`
  border-bottom: 1px solid ${colors.neutral.trim.default};
  display: flex;
  flex-direction: column;
  gap: ${spacing.s};
  padding-bottom: ${spacing.l};
  user-select: none;
`;

export const top = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
`;

export const ratingAndBadgeRow = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const ratingAndTimestamp = css`
  align-items: center;
  display: flex;
  gap: ${spacing.xs};
`;

export const stars = css`
  align-items: center;
  display: flex;
  line-height: 0;
`;

export const dotSeparator = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.medium.default};
`;

export const relativeDate = css`
  ${applyFont(typography.caption)}
  color: ${colors.neutral.medium.default};
`;

export const propertyInfo = css`
  ${applyFont(typography.caption)}
  color: ${colors.neutral.medium.default};
`;

export const reviewCopy = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
`;

export const title = css`
  ${applyFont(typography.lead)}
  color: ${colors.neutral.heavy.default};
  margin: 0;
`;
